/*
Lalitha 12/19/2022  3075154998 Added Search Data Manager Record Table
Lalitha 12/20/2022  3075154998 Added Created Date in Data Manager Record Table
Lalitha 12/21/2022  3075154998 Integrated search Api
Lalitha 12/22/2022  3075154998 Integrated Delete Api
Sohel 12/22/2022 3075154998 fixed toast message issue.
Sohel 12/28/2022 3075154998 Added edit icon.
Sohel 01/03/2023 3075154998 Map Record Group Changes
Sohel 01/03/2023 2701323910 payload Changes
Sohel 04/01/2023 3075154998 changed field label name
Sohel 04/01/2023 3075154998 Added Mapped Records functionality
Sohel 01/05/2023 3075154998 pass Fixed Length props
dilip 01/06/2023 3075154998 added save and close for mapped data
Sohel 01/06/2023 3075154998 added condition on For API call in Table
Sohel 01/06/2023 3075154998 changed Condition
dilip 01/09/2023 3075154998 Added search data local storage
Sohel 01/10/2023 2699388043 Implemented Copy Functionality
kavyareddy 01/10/2023 3075154998 Fixed delete issue
Dilip 01/11/2023 2699388043 Implemented System Notes Functionality
Sohel 01/11/2023 2699388043 pass isDraft
dilip 01/11/2023 2699388043 payload change
Sohel 01/11/2023 2699389646 pass props System Notes
dilip 01/11/2023 2699388043 implemented download configuration functionality
Sohel 01/12/2023 2699388043 hide Download Configuration
dilip 01/12/2023 2699388043 Added Conditions for Exception Records.
Sohel 01/12/2023 2698964415 fixed loader issue
Ashraf 01/12/2023 2699388043 disable download button when records
Sohel 01/12/2023 2699388043 Added Record Code in Delete Popup
dilip 01/12/2023 2699388043 Fixed check box disable issue.
 dilip 01/16/2023 2699388043 Added Master Record payload for search records.
Sohel 01/18/2023 2699388043 fixed reset Issue
Sohel 01/18/2023 3075154998 Download Configuration Payload Changes
Sohel 01/18/2023 2698951347 Fixed Status  issue
Sohel 01/20/2023 2698964415 Added Last Step in Stepper
sai krishna 01/20/2023 2698951347 renamed notes tooltip
Sohel 01/20/2023 2698951347 Fixed page break issue
Sohel 01/23/2023 2698964415 fixed length populate issue
Ashraf 01/27/2023 2698964415 added new columns audit and category
Sohel 01/30/2023 2698964415 Payload Changes
Sohel 01/31/2023 2698964415 label changes
Dilip 01/31/2023 2698964415 label and title changes
Sohel 01/02/2023 2698951347 fixed code hyperlink issue
Sohel 02/01/2023 2698964415 set record Type
sai krishna 02/03/2023 2698964415 updated downloadconfiguration payload
Dilip 02/09/2023 2698964415 added creted for column and payload changes
Sohel 01/08/2023 2701335619 Implemented Usage Functionality
Sohel 02/08/2023 2701335619 Implement Usage Functionality
Sohel 02/08/2023 2698951347 fixed record Type reset issue
Rohini 02/09/2023 2698951347 added classname  for the table
Ravi 02/09/2023 2698951347 Added used in Usage Toast Messege
Dilip 02/10/2023 2698964415 added creted by and creted for changed payload
Dilip 02/10/2023 2698964415 changed Column Positions
Prakash 02/14/2023 2698964415 Reverted New UI Changes.
suresh peddavoora 02/22/2023 2698964415 New UI changes fixed

Sohel 02/24/2023 2698964415 usage popup title changes
Dilip 02/24/2023 2698964415 implemented preview file functionality in download configuration
Sohel 02/24/2023 2698964415 Download Configuration Payload Changes
Dilip 02/27/2023 2698964415 Fixed Sorting issue
Dilip 02/28/2023 2698964415 payload change
Ravi 03/01/2023 2698964415 Added loader and download toast message for preview File
Sohel 02/03/2023 2701335619 header line changes
T Santosh Kumar 15/03/2023 2698964415 Responsive UI Changes
Sohel 03/15/2023 2701335619 hide Duplicate Criteria Based on condition
Suresh Peddavoora 03/15/2023 2701335619 Added Dropdown menu in Action Column in table
Suresh Peddavoora 03/16/2023 2701335619 Added Dropdown menu in Action Column in table
Raghu 03/04/2023 2701335619 added plus icon
Akhila 05/04/2023 2701335619 Added update date column and in payload
Ravi 05/31/2023 2701335619  changed delete popup message
Akhila 06/06/2023 2701335619 added code and description in action
Akhila 06/08/2023 2701335619 title label placeholder name change
Akhila 06/08/2023 2701335619 rearrange the column and form fields
Akhila 06/09/2023 2701335619 bug fix label name condtionally implemented
Akhila 06/12/2023 2701335619 added role access
Sohel 10/18/2023 2701335619 Fixed Master Record Value Issue
Sohel 10/18/2023 2701335619 Changed Master Record condition
uday  19/10/2023 2701335619 fixed add table scroll issue
Sohel 12/12/2023 2701335619 column name change code to name 
*/

import React, {createRef, useState, useEffect, useRef} from 'react';
import {TablePagination, Grid, Button, makeStyles} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import moment from 'moment';
import PageLoader from '../../../../../components/PageLoader';
import {useUpdateEffect} from 'react-use';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import ImportManagerRecordNotes from './ImportManagerRecordNotes';
import {
  fetchBasicInfoData,
  resetBasicInfo,
  resetDataManagerRecord,
  setDraftStatusRedux,
  postPrintImportRecordGroup,
  resetBasicInfoRecord,
  setLastStepRedux,
  setFixedLengthRedux,
  fetchDataManagerRecordUsage,
  resetDataManagerRecordUsage,
  resetConfigUrl,
  resetDockey,
  setHeaderLinesRedux,
  setIsAccountNumbersRedux,
} from '../../../../../redux/reducers/DataManagerRecord';
import {
  ErrorSnackbar,
  SuccessSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import CopyDataManagerRecord from './CopyDataManagerRecord';
import DialogBox from '../../../../../components/DialogBox';
import {useSelector} from 'react-redux';
import {setRecordGroupRedux} from '../../../../../redux/reducers/DataManagerRecordGroup';
import UsageMessage from '../../../../../util/UsageMessage';
import OverrideRule from '../../../../../components/OverrideRule';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import {downloadButton} from '../../../../../util/Content';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import AddIcon from '@material-ui/icons/AddOutlined';

const useStyles = makeStyles((theme) => ({
  'link': {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));

function SearchDMRecordTable({
  setValue = () => {},
  searchData,
  submit,
  setSubmit,
  tempSelectedRows = [],
  setTempSelectedRows,
  tempUnCheckedRef,
  mapRecord,
  recordGroupValues,
  recordGroupType,
  records = [],
  fixedLength,
  isRecordGroup,
  exportManagerRecordGroup,
  mapRecordForException,
  mappedRecordForExceptionData,
  setMappedRecordForExceptionData = () => {},
  mappingMasterRecordTypes,
  parentRecordException,
  masterRecordValue,
  includeAudit,
  category,
  setDataManagerRecordData = () => {},
  dmTempRecordAccess,
  setEditExisting,
  setImTemRecEditing,
}) {
  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const dispatch = useDispatch();
  const classes1 = useStyles();
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [resultCount, setResultCount] = useState(0);
  const deletedId = useRef(null);
  const queryRef = useRef(null);
  const [copyDataManagerRecord, setCopyDataManagerRecord] = useState(false);
  const [oldDmrCodeData, setOldDmrCodeData] = useState(null);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const {
    basicInfoSuccessMsg,
    basicInfoErrorMsg,
    basicInfoStatus,
    isBasicInfoLoading,
    dataManagerRecordUsage,
    configurationUrl,
    dockey,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const [isNote, setIsNote] = useState(false);
  const [dmData, setDmData] = useState();
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isUsage, setIsUsage] = useState(false);

  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);
  const type = exportManagerRecordGroup ? 'Export' : 'Import';
  const onEditCall = (rowData) => {
    dispatch(
      setDraftStatusRedux({
        property: 'isDraftRecord',
        value: rowData.isDraft,
      }),
    );
    dispatch(
      setLastStepRedux({
        property: 'lastStep',
        value: rowData.lastStep,
      }),
    );

    dispatch(
      setFixedLengthRedux({
        property: 'fixedLength',
        value: rowData?.fixedLength,
      }),
    );
    dispatch(
      setRecordGroupRedux({
        property: 'recordType',
        value: {value: rowData?.recordType},
      }),
    );
    dispatch(setHeaderLinesRedux({property: 'headerLines', value: rowData?.headerLineNumbers}));
    dispatch(
      setIsAccountNumbersRedux({
        property: 'isAccountNumbers',
        value: rowData?.isAccountNumberPresent,
      }),
    );
  };
  const columns = [
    {
      title: 'Category',
      field: 'category',
      hidden: !exportManagerRecordGroup,
      render: (rowData) => {
        return rowData?.category === 'CL' ?
          'CL - Client' :
          rowData?.category === 'CO' ?
            'CO - Core' :
            rowData?.category === 'PA' ?
              'PA - Payment' :
              '';
      },
    },
    {
      title: `${type} Template Record Name`,
      field: 'recordCode',
      render: (rowData) =>
        isRecordGroup || mapRecord ? (
          rowData?.recordCode
        ) : (
          <span
            role="button"
            className={classes1.link}
            onClick={() => {
              onEditCall(rowData);
              setEditExisting(type);
              dispatch(fetchBasicInfoData(rowData?.dataManagerRecordId));
              setValue(1);
            }}
          >
            {rowData?.recordCode?.replace(/ /g, '\u00a0')}
          </span>
        ),
    },
    {
      title: `${type} Template Description`,
      field: 'recordDescription',
      render: (rowData) => rowData?.recordDescription?.replace(/ /g, '\u00a0')
    },
    {
      title: 'Record Type',
      field: 'recordType',
    },
    {
      title: 'Master Record',
      field: 'masterRecord',
      hidden: mapRecord,
      render: (rowData) => {
        return ['New Account Import', 'Data Update']?.includes(rowData?.recordType) ?
          rowData?.masterRecord === 'Y' ?
            'Yes' :
            'No' :
          '';
      },
    },
    {
      title: 'Created For',
      field: 'createdFor',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Updated Date',
      field: 'updatedDate',
      render: (rowData) => {
        return rowData?.updatedDate ?
          moment(rowData?.updatedDate).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
  ];
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const handleDelete = (rowData) => {
    dispatch(fetchDataManagerRecordUsage(type, rowData.dataManagerRecordId));
    setIsDelete(false);
    setDeleteUsage(true);
    deletedId.current = rowData;
  };
  useEffect(() => {
    if (setTempSelectedRows) {
      setTempSelectedRows([]);
      tempUnCheckedRef.current = [];
    }
  }, []);
  const handleCopyDataManagerRecord = () => {
    setCopyDataManagerRecord(false);
  };
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  useEffect(() => {
    !mapRecord && dispatch(resetDataManagerRecord());
  }, []);

  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 1500);
    }
  }, [tstmsg, deleteErrorMsg]);

  const handleClose = () => {
    setIsDelete(false);
    setUserMetrixDelete(false);
  };
  const handleCloseNotesDialog = () => {
    setIsNote(false);
  };
  useEffect(() => {
    if (basicInfoErrorMsg || basicInfoSuccessMsg) {
      if (oldDmrCodeData?.isDraft) {
        dispatch(
          setDraftStatusRedux({
            property: 'isDraftRecord',
            value: oldDmrCodeData.isDraft ? oldDmrCodeData.isDraft : '',
          }),
        );
      }
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);
  useEffect(() => {
    if (basicInfoStatus === 200 && basicInfoSuccessMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
        setValue(1);
        if (oldDmrCodeData?.recordCode) {
          onEditCall(oldDmrCodeData);
        }
      }, 1500);
    }
  }, [basicInfoStatus, basicInfoSuccessMsg]);
  const handleSubmit = () => {
    httpPaginationDelete(
        `data-manager/record/delete/record/${deletedId.current?.dataManagerRecordId}`,
    )
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedForDropDownData('importtemplaterecord'));
      dispatch(fetchCreatedByDropDownData('importtemplate'));
      setStatus(false);
    }
  }, [status]);

  const IMRecordSessionStorage = JSON.parse(sessionStorage.getItem('IMRecord'));
  if (IMRecordSessionStorage && !submit && !mapRecord) {
    searchData = IMRecordSessionStorage;
  }

  useEffect(() => {
    dispatch(
      setDraftStatusRedux({
        property: 'isDraftRecord',
        value: '',
      }),
    );
    dispatch(
      setLastStepRedux({
        property: 'lastStep',
        value: 0,
      }),
    );
    dispatch(
      setFixedLengthRedux({
        property: 'fixedLength',
        value: '',
      }),
    );
    if (!isRecordGroup && !mapRecord) {
      dispatch(
        setRecordGroupRedux({
          property: 'recordType',
          value: {},
        }),
      );
    }
    dispatch(
      setHeaderLinesRedux({
        property: 'headerLines',
        value: null,
      }),
    );
    dispatch(
      setIsAccountNumbersRedux({
        property: 'isAccountNumbers',
        value: '',
      }),
    );
  }, []);
  useEffect(() => {
    dispatch(resetBasicInfo());
    dispatch(resetBasicInfoRecord());
  }, []);
  useEffect(() => {
    if (dataManagerRecordUsage?.userMetrix === 'No') {
      if (deleteUsage) {
        setUserMetrixDelete(false);
        setIsDelete(true);
      } else {
        setCustomError(true);
        setTimeout(() => {
          setCustomError(false);
          dispatch(resetDataManagerRecordUsage());
        }, 3000);
      }
    } else if (dataManagerRecordUsage?.userMetrix === 'Yes') {
      if (deleteUsage) {
        setIsDelete(true);
        setUserMetrixDelete(true);
      } else {
        setValue(2);
      }
    }
  }, [dataManagerRecordUsage]);
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      setIsUsage(true);
      setIsDelete(false);
      setUserMetrixDelete(false);
    } else {
      handleSubmit();
    }
  };
  useEffect(() => {
    setCustomError(false);
    setValue(0);
    isDelete && setIsDelete(false);
  }, []);

  const handleEdit = (rowData) => {
    setEditExisting(true);
    onEditCall(rowData);
    dispatch(fetchBasicInfoData(rowData?.dataManagerRecordId));
    setValue(1);
  };

  const handleCopy = (rowData) => {
    setOldDmrCodeData(rowData);
    setCopyDataManagerRecord(true);
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setDmData(rowData);
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setDataManagerRecordData(rowData);
    dispatch(fetchDataManagerRecordUsage(type, rowData.dataManagerRecordId));
  };
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Import Template Record'}
      />
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title={userMetrixDelete ? 'Import Template Records Usage' : 'Delete Import Template Record'}
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Import Template Record'} />
          ) : (
            `Are you sure want to delete the ${deletedId.current?.recordCode?.replace(/ /g, '\u00a0')} Import Template Record ?`
          )
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleDeleteUsage}
      />
      <OverrideRule
        dialogTitle="Import Template Records Usage"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`${deletedId.current?.recordCode?.replace(/ /g, '\u00a0') || ''} - ${
          deletedId.current?.recordDescription?.replace(/ /g, '\u00a0') || ''
        } Import Template Records has been used in the following Imports.`}
        data={dataManagerRecordUsage?.placeResponse}
        isOverRide={false}
      />
      <DialogBox
        open={copyDataManagerRecord}
        dialogClose={handleCopyDataManagerRecord}
        title={`Copy ${type} Template Record`}
        maxWidth="md"
        hideFooter={true}
      >
        <CopyDataManagerRecord oldDmrCodeData={oldDmrCodeData} type={type} />
      </DialogBox>
      <DialogBox
        open={isNote}
        dialogClose={handleCloseNotesDialog}
        title="Import Template Record Notes"
        maxWidth="lg"
      >
        <ImportManagerRecordNotes
          dmTempRecordAccess={dmTempRecordAccess}
          dmrData={dmData}
          type={'Import'}
        />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table global-field-table actions-dropdown-table custom-toolbar-icons custom-actions-icon new-standard-textfields tablescroll-block">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (tempSelectedRows) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    tableData: {...row.tableData, id: row.recordCode},
                  });
                  setTempSelectedRows(arr);
                }
              } else {
                tempUnCheckedRef.current.push(row);
                const updatedRows = [...tempSelectedRows]
                  .filter((ele) => ele?.recordCode !== row?.recordCode)
                  .map((ele) => {
                    return {
                      ...ele,
                    };
                  });
                setTempSelectedRows(updatedRows);
              }
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-manager/record/search/all`;
                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  recordCode: searchData?.code ? searchData?.code : '',
                  recordType: mappingMasterRecordTypes ?
                    mappingMasterRecordTypes :
                    searchData?.recordType?.value ?
                      [searchData?.recordType?.value] :
                      [],
                  subRecordType: recordGroupType?.subRecordType || '',
                  recordDescription: searchData?.recordDescription ?
                    searchData?.recordDescription :
                    '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData.createdBy?.userLoginName :
                    '',
                  createdFor: searchData?.createdFor?.userLoginName ?
                    searchData.createdFor?.userLoginName :
                    '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  fixedLength: isRecordGroup && fixedLength ? fixedLength : '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  type: exportManagerRecordGroup ? 'Export' : 'Import',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  masterRecord:
                    mapRecord && parentRecordException ?
                      parentRecordException :
                      searchData?.masterRecord?.key ?
                        searchData?.masterRecord?.key :
                        '',
                  includeAudit: exportManagerRecordGroup ? includeAudit : '',
                  category: category,
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        const newObj = {};

                        if (isRecordGroup) {
                          [...recordGroupValues.groupRecords, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.recordCode]) {
                              newObj[el.recordCode] = el;
                            }
                          });
                        }
                        if (records) {
                          [...records, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.recordCode]) {
                              newObj[el.recordCode] = el;
                            }
                          });
                        }
                        if (mappedRecordForExceptionData && mappedRecordForExceptionData) {
                          [mappedRecordForExceptionData, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.recordCode]) {
                              newObj[el.recordCode] = el;
                            }
                          });
                        }
                        const newRows = data?.map((elem) => {
                          if (newObj[elem.recordCode]) {
                            return {...elem, tableData: {...elem.tableData, checked: true}};
                          } else {
                            return {
                              ...elem,
                              tableData: {...elem.tableData, checked: false},
                            };
                          }
                        });
                        resolve({
                          data:
                            mapRecord && newRows?.length > 0 ?
                              newRows :
                              data.length > 0 ?
                                data :
                                [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                        setResultCount(response?.data?.response?.count);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: !mapRecord,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              selection: mapRecord,
              selectionProps: (row) => {
                let isDisabled = false;
                if (
                  recordGroupType?.value &&
                  !isRecordGroup &&
                  recordGroupType?.value !== 'Exception'
                ) {
                  const HeaderSelected = [...records, ...tempSelectedRows].filter(
                    (item) => item.recordType === recordGroupType?.value,
                  );
                  if (
                    HeaderSelected?.length === 1 &&
                    row.recordCode !== HeaderSelected[0]?.recordCode &&
                    recordGroupType?.value !== 'Data Export'
                  ) {
                    isDisabled = true;
                  }
                }
                if (mapRecordForException) {
                  if (
                    tempSelectedRows?.length === 0 &&
                    mappedRecordForExceptionData &&
                    mappedRecordForExceptionData?.recordCode !== row.recordCode
                  ) {
                    isDisabled = true;
                  }
                  if (
                    tempSelectedRows?.length > 0 &&
                    tempSelectedRows?.[0]?.recordCode !== row.recordCode &&
                    !mappedRecordForExceptionData
                  ) {
                    isDisabled = true;
                  }
                }
                if (isRecordGroup && masterRecordValue === 'Y') {
                  const masterRecords = [
                    ...recordGroupValues?.groupRecords,
                    ...tempSelectedRows,
                  ].filter((item) => item?.masterRecord === 'Y');
                  if (
                    masterRecords?.length >= 1 &&
                    row?.recordCode !== masterRecords?.[0].recordCode
                  ) {
                    isDisabled = true;
                  }
                }
                return {
                  disabled: isDisabled,
                };
              },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={
              mapRecord ?
                [] :
                [
                  {
                    icon: () => <SaveIcon />,
                    tooltip: 'Save User',
                    onClick: (event, rowData) => console.log(rowData, 'rowData'),
                  },
                ]
            }
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer pagination-block">
                  {!(isRecordGroup || mapRecord) && (
                    <div className="mt-2">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(resultCount === 0)}
                        onClick={(event) => {
                          dispatch(
                            postPrintUsage({
                              baseCategory: '',
                              code: '',
                              description: '',
                              displayName: '',
                              fileType: '',
                              recordFormatType: '',
                              returnType: '',
                              sourceType: 'IMPORT TEMPLATE RECORD',
                              isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                              masterRecord: searchData?.masterRecord?.key ?
                                searchData?.masterRecord?.key :
                                '',
                              search: '',
                              frameworkUsageOrderBy: '',
                              frameworkUsageOrderDerection: '',
                              fieldListOrderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                  queryRef.current.orderBy.field :
                                  '',
                              fieldListOrderDerection: queryRef.current?.orderDirection ?
                                queryRef.current?.orderDirection :
                                '',
                              category: category,
                              fieldName: '',
                              repositoryDescription: '',
                              repositoryName: '',
                              repositoryType: '',
                              createdBy: '',
                              recordCode: searchData?.code ? searchData?.code : '',
                              recordDescription: searchData?.recordDescription ?
                                searchData?.recordDescription :
                                '',
                              recordType: searchData?.recordType?.value ?
                                searchData?.recordType?.value :
                                '',
                              createdDate: searchData?.createdDate ?
                                moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                '',
                              includeAudit: '',
                            }),
                          );
                        }}
                      >
                        Download Configuration Usage
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        disabled={resultCount === 0}
                        className={`search-btn ml-2 ${classes1.buttonRoot}`}
                        onClick={() => {
                          dispatch(
                            postPrintImportRecordGroup(
                              {
                                recordCode: searchData?.code ? searchData?.code : '',
                                recordType: searchData?.recordType?.value ?
                                  [searchData?.recordType?.value] :
                                  [],
                                recordDescription: searchData?.recordDescription ?
                                  searchData?.recordDescription :
                                  '',
                                createdDate: searchData?.createdDate ?
                                  moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                  '',
                                orderBy:
                                  queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                    queryRef.current.orderBy.field :
                                    '',
                                orderDirection: queryRef.current?.orderDirection ?
                                  queryRef.current?.orderDirection :
                                  '',
                                isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                                masterRecord: searchData?.masterRecord?.key ?
                                  searchData?.masterRecord?.key :
                                  '',
                                createdBy: searchData?.createdBy?.userLoginName ?
                                  searchData.createdBy?.userLoginName :
                                  '',
                                createdFor: searchData?.createdFor?.userLoginName ?
                                  searchData.createdFor?.userLoginName :
                                  '',
                                type: 'Import',
                              },
                              'Import',
                            ),
                          );
                        }}
                      >
                        {downloadButton}
                      </Button>
                    </div>
                  )}

                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  // handleRun={handleRun}
                  // handleExecution={handleExecution}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: false,
                    run: true,
                    copy: false,
                    test: true,
                    notes: false,
                    execution: true,
                    usage: false,
                    user: true,
                    password: true,
                    delete: false,
                  }}
                  disableMenu={{
                    disableEdit: !dmTempRecordAccess?.edit,
                    disableCopy: !dmTempRecordAccess?.add,
                    disableDelete: !dmTempRecordAccess?.delete,
                    disableNotes: false,
                    disableExecution: false,
                    disableTest: false,
                    disableRun: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    delete: true,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {/* {mapRecord && ( */}
                    <Button
                      type="button"
                      variant="outlisetOpenned"
                      className={`mx-1 search-btn`}
                      disabled={!dmTempRecordAccess?.add}
                      isFreeAction={true}
                      onClick={(event) => {
                        dispatch(resetDataManagerRecord());
                        dispatch(
                          setDraftStatusRedux({
                            property: 'isDraftRecord',
                            value: '',
                          }),
                        );
                        dispatch(
                          setLastStepRedux({
                            property: 'lastStep',
                            value: 0,
                          }),
                        );
                        setValue(1);
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Import Template Record
                    </Button>
                    {/* )} */}
                  </div>
                </div>
              ),
            }}
            // actions={
            //   mapRecord
            //     ? []
            //     : [
            //         {
            //           icon: () => (
            //             <>
            //               <Button type="button" variant="outlined" className={`search-btn`}>
            //                 Add Record
            //               </Button>
            //             </>
            //           ),
            //           isFreeAction: true,
            //           onClick: () => {
            //             dispatch(resetDataManagerRecord());
            //             dispatch(
            //               setDraftStatusRedux({
            //                 property: "isDraftRecord",
            //                 value: "",
            //               })
            //             );
            //             dispatch(
            //               setLastStepRedux({
            //                 property: "lastStep",
            //                 value: 0,
            //               })
            //             );
            //             setValue(1);
            //           },
            //         },
            //         {
            //           icon: () => <EditOutlinedIcon />,
            //           tooltip: "Edit",
            //           onClick: (event, rowData) => {
            //             onEditCall(rowData);
            //             dispatch(fetchBasicInfoData(type, rowData?.recordCode));
            //             setValue(1);
            //           },
            //         },
            //         {
            //           icon: () => (
            //             <>
            //               <FileCopyOutlinedIcon />
            //             </>
            //           ),
            //           tooltip: "Copy",
            //           onClick: (event, rowData) => {
            //             setOldDmrCodeData(rowData);
            //             setCopyDataManagerRecord(true);
            //           },
            //         },
            //         {
            //           icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
            //           tooltip: "Usage",
            //           onClick: (event, rowData) => {
            //             setDeleteUsage(false);
            //             setDataManagerRecordData(rowData);
            //             dispatch(fetchDataManagerRecordUsage(type, rowData.recordCode));
            //           },
            //         },
            //         (rowData) => {
            //           return {
            //             icon: () => (
            //               <>
            //                 <DeleteOutlineOutlinedIcon />
            //               </>
            //             ),
            //             tooltip: "Delete",
            //             onClick: () => {
            //               handleDelete(rowData);
            //             },
            //           };
            //         },
            //         {
            //           icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //           tooltip: "Import Template Record Notes",
            //           onClick: (event, rowData) => {
            //             setIsNote(true);
            //             setDmData(rowData?.recordCode);
            //           },
            //         },
            //       ]
            // }
          />
        </div>
      </Grid>
      {(loading || isBasicInfoLoading || printUsageIsLoading) && <PageLoader />}
      {(deleteErrorMsg || basicInfoErrorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={deleteErrorMsg || basicInfoErrorMsg || printUsageErrorMsg} />
      )}
      {(tstmsg || basicInfoSuccessMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={tstmsg || basicInfoSuccessMsg || printUsageSuccessMsg} />
      )}
      {customError && (
        <WarningSnackbar errorMsg={`This ${type} Template Record is not being used anywhere`} />
      )}
    </>
  );
}

export default SearchDMRecordTable;
